// extracted by mini-css-extract-plugin
module.exports = {"container":"Menu_container__ua5yR","foodsContainer":"Menu_foodsContainer__eE8F_"};